import { makeStyles } from "@material-ui/core/styles";
import { RefObject, useEffect, useRef, useState } from "react";
import { useVirtualScrollDummyCard } from "../../../../../../common/hooks/useVirtualScrollDummyCard";
import { BasicRankingRecord } from "../../../../../zApps/zApps/parts/Ranking/LevelRanking/BasicRanking/BasicRankingRecord";
import { RankingRecordContainer } from "../../../../../zApps/zApps/parts/Ranking/LevelRanking/RankingRecordContainer";
import ShurikenProgress from "../../../../Animations/ShurikenProgress";
import { UserForRanking } from "../../../types";

export function PcListArea({
    users,
    loading,
    scrollableContainerRef,
    screenHeight,
}: {
    users: UserForRanking[];
    loading?: boolean;
    scrollableContainerRef: RefObject<HTMLDivElement>;
    screenHeight: number;
}) {
    const c = useSpListAreaStyles();
    const [scrollTop, setScrollTop] = useState(0);
    const listContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = scrollableContainerRef.current;
        if (!el) {
            return;
        }
        const onScroll = () => {
            const top =
                listContainerRef?.current?.getBoundingClientRect()?.top ?? 0;
            setScrollTop(-top);
        };
        setScrollTop(el.scrollTop);
        el.addEventListener("scroll", onScroll);
        return () => {
            el.removeEventListener("scroll", onScroll);
        };
    }, [scrollableContainerRef]);

    return (
        <div className={c.listCard} ref={listContainerRef}>
            {users.map((user, i) => {
                return (
                    <Record
                        key={user.userId}
                        user={user}
                        i={i}
                        scrollableContainerRef={scrollableContainerRef}
                        screenHeight={screenHeight}
                        scrollTop={scrollTop}
                    />
                );
            })}
            {(users.length === 0 || loading) && (
                <ShurikenProgress
                    size={50}
                    style={
                        users.length === 0
                            ? { marginTop: 142 }
                            : { margin: "30px 0" }
                    }
                />
            )}
        </div>
    );
}

const useSpListAreaStyles = makeStyles({
    listCard: {
        flex: 1,
        fontSize: "large",
        position: "relative",
        width: "100%",
        paddingTop: 32,
    },
});

function Record({
    user,
    i,
    scrollableContainerRef,
    scrollTop,
    screenHeight,
}: {
    user: UserForRanking;
    i: number;
    scrollableContainerRef: RefObject<HTMLDivElement>;
    scrollTop: number;
    screenHeight: number;
}) {
    const c = useRecordStyles();

    const { cardRef, isDummyCard } = useVirtualScrollDummyCard(
        scrollTop,
        screenHeight,
        55,
        i
    );

    if (isDummyCard) {
        return <div className={c.dummyCard} ref={cardRef} key="outsideCard" />;
    }

    return (
        <RankingRecordContainer
            key="outsideCard"
            userId={user.userId}
            cardRef={cardRef}
        >
            <BasicRankingRecord
                user={user}
                rank={i}
                scrollableContainer={scrollableContainerRef.current}
                collapseOpen
                isMyself={false}
                isRankNumberHidden
            />
        </RankingRecordContainer>
    );
}
const useRecordStyles = makeStyles({
    dummyCard: {
        height: 55,
    },
});
